var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitFormAddress.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3 col-12" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("message.company_address.type")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-3 col-6" }, [
            _c("div", { staticClass: "exp" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.company.is_company,
                      expression: "company.is_company"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "juristicPerson",
                    name: "isCompany"
                  },
                  domProps: {
                    value: 1,
                    checked: _vm._q(_vm.company.is_company, 1)
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.company, "is_company", 1)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "mb-0", attrs: { for: "juristicPerson" } },
                  [
                    _c("span"),
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("message.company_address.juristic_person")
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-3 col-6" }, [
            _c("div", { staticClass: "exp" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.company.is_company,
                      expression: "company.is_company"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "normalPerson",
                    name: "isCompany"
                  },
                  domProps: {
                    value: 0,
                    checked: _vm._q(_vm.company.is_company, 0)
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.company, "is_company", 0)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "mb-0", attrs: { for: "normalPerson" } },
                  [
                    _c("span"),
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("message.company_address.normal_person")
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-3 col-12" }, [
            _vm.errors.has("companyType")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "company" } }, [
              _vm._v(
                "\n          " + _vm._s(_vm.companyNameLabel) + "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.company.company,
                  expression: "company.company",
                  modifiers: { trim: true }
                }
              ],
              class: {
                "form-control": true,
                "is-invalid": _vm.errors.has("company")
              },
              attrs: { id: "company", type: "text", name: "company" },
              domProps: { value: _vm.company.company },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.company, "company", $event.target.value.trim())
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("company")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "tax_id" } }, [
              _vm._v(_vm._s(_vm.$t("message.company_address.tax_id")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|digits:13",
                  expression: "'required|digits:13'"
                },
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.company.tax_id,
                  expression: "company.tax_id",
                  modifiers: { trim: true }
                }
              ],
              class: {
                "form-control": true,
                "is-invalid": _vm.errors.has("taxId")
              },
              attrs: {
                id: "taxId",
                type: "text",
                name: "taxId",
                maxlength: "13"
              },
              domProps: { value: _vm.company.tax_id },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.company, "tax_id", $event.target.value.trim())
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("taxId")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.company.is_company === null || _vm.company.is_company === 1
          ? _c("div", { staticClass: "row mb-3 no-gutters" }, [
              _c("div", { staticClass: "col-sm-3 col-12" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.company_address.type")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3 col-6" }, [
                _c("div", { staticClass: "exp" }, [
                  _c("div", { staticClass: "checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.company.company_type,
                          expression: "company.company_type"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: { type: "radio", id: "hq", name: "companyType" },
                      domProps: {
                        value: 1,
                        checked: _vm._q(_vm.company.company_type, 1)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.company, "company_type", 1)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "mb-0", attrs: { for: "hq" } }, [
                      _c("span"),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("message.company_address.hq")) +
                          "\n            "
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3 col-6" }, [
                _c("div", { staticClass: "exp" }, [
                  _c("div", { staticClass: "checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.company.company_type,
                          expression: "company.company_type"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: "branch",
                        name: "companyType"
                      },
                      domProps: {
                        value: 2,
                        checked: _vm._q(_vm.company.company_type, 2)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.company, "company_type", 2)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "mb-0", attrs: { for: "branch" } },
                      [
                        _c("span"),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("message.company_address.branch")) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3 col-12" }, [
                _vm.errors.has("companyType")
                  ? _c(
                      "div",
                      { staticClass: "mt-1 text-remark -status-alert" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.required_field")) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.company.is_company === 1 && _vm.company.company_type === 2
          ? _c("div", { staticClass: "row mb-3 no-gutters" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c("label", { staticClass: "tinNumber" }, [
                  _vm._v(_vm._s(_vm.$t("message.company_address.tin_number")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-9" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    },
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.company.tin_number,
                      expression: "company.tin_number",
                      modifiers: { trim: true }
                    }
                  ],
                  class: {
                    "form-control": true,
                    "is-invalid": _vm.errors.has("tinNumber")
                  },
                  attrs: { id: "tinNumber", name: "tinNumber", type: "text" },
                  domProps: { value: _vm.company.tin_number },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.company,
                        "tin_number",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.has("tinNumber")
                  ? _c(
                      "div",
                      { staticClass: "mt-1 text-remark -status-alert" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.required_field")) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("section", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "email" } }, [
              _vm._v(_vm._s(_vm.$t("message.company_address.email")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "'required|email'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.company.email,
                  expression: "company.email"
                }
              ],
              class: {
                "form-control": true,
                "is-invalid": _vm.errors.has("email")
              },
              attrs: { id: "email", name: "email", type: "text" },
              domProps: { value: _vm.company.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.company, "email", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("email")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "tel" } }, [
              _vm._v(_vm._s(_vm.$t("message.company_address.tel")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.company.tel,
                  expression: "company.tel"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: {
                    required: true,
                    min: 10,
                    max: 15,
                    regex: /^\+?[0-9-]+$/
                  },
                  expression:
                    "{ required: true, min: 10, max: 15, regex: /^\\+?[0-9-]+$/ }"
                }
              ],
              class: {
                "form-control": true,
                "is-invalid": _vm.errors.has("tel")
              },
              attrs: { id: "tel", name: "tel", type: "tel" },
              domProps: { value: _vm.company.tel },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.company, "tel", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("tel")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-5 mb-3 no-gutters" }, [
          _c("div", { staticClass: "col" }, [
            _c("h3", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.company.is_company === null ||
                      _vm.company.is_company === 1
                      ? _vm.$t("message.company_address.company_address")
                      : _vm.$t("message.company_address.customer_address")
                  ) +
                  "\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "companyAddress" } }, [
              _vm._v(_vm._s(_vm.$t("message.my_listings.address")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("textarea", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.company.company_address,
                  expression: "company.company_address",
                  modifiers: { trim: true }
                }
              ],
              class: {
                "form-control": true,
                "is-invalid": _vm.errors.has("companyAddress")
              },
              attrs: {
                id: "companyAddress",
                name: "companyAddress",
                placeholder: _vm.$t(
                  "message.company_address.location_placeholder"
                ),
                rows: "3"
              },
              domProps: { value: _vm.company.company_address },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.company,
                    "company_address",
                    $event.target.value.trim()
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("companyAddress")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "companyAddressId" } }, [
              _vm._v(_vm._s(_vm.$t("message.company_address.province")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company.address_province_id,
                    expression: "company.address_province_id"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                class: { "form-alert": _vm.errors.has("addressProvinceId") },
                attrs: { id: "addressProvinceId", name: "addressProvinceId" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.company,
                        "address_province_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function($event) {
                      return _vm.changeAddressProvince(
                        _vm.company.address_province_id
                      )
                    }
                  ]
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.contact_step.set_province"))
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.sortedProvinces, function(addressProvince, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: addressProvince.id } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("multiLangName")(addressProvince)) +
                          "\n          "
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.errors.has("addressProvinceId")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "districtId" } }, [
              _vm._v(_vm._s(_vm.$t("message.company_address.district")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company.district_id,
                    expression: "company.district_id"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                class: { "form-alert": _vm.errors.has("districtId") },
                attrs: { id: "districtId", name: "districtId" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.company,
                        "district_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function($event) {
                      return _vm.changeDistrict(_vm.company.district_id)
                    }
                  ]
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.contact_step.set_district"))
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.sortedDistricts, function(district, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: district.id } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("multiLangName")(district)) +
                          "\n          "
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.errors.has("districtId")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 no-gutters" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c("label", { attrs: { for: "subDistrictId" } }, [
              _vm._v(_vm._s(_vm.$t("message.company_address.sub_district")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company.sub_district_id,
                    expression: "company.sub_district_id"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                class: { "form-alert": _vm.errors.has("subDistrictId") },
                attrs: { id: "subDistrictId", name: "subDistrictId" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.company,
                      "sub_district_id",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.booking.contact_step.set_sub_district")
                    )
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.sortedSubDistricts, function(subDistrcict, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: subDistrcict.id } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(subDistrcict.zip_code) +
                          " - " +
                          _vm._s(_vm._f("multiLangName")(subDistrcict)) +
                          "\n          "
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.errors.has("subDistrictId")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24768884", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24768884","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/CompanyAddressForm.vue
// module id = 1827
// module chunks = 0